import {
  Home,
  FolderOpen,
  Video,
  Image,
  Film,
  CreditCard,
  Users,
} from 'lucide-react'
import type { PlanType } from '@/stores/user-store'

export interface NavItem {
  icon: React.ElementType
  label: string
  href: string
  /** If true, this item will be styled specially (e.g., upgrade button) */
  isSpecial?: boolean
  /** Minimum plan required to access this feature (shows crown if user doesn't have it) */
  requiresPlan?: PlanType
}

// Plan hierarchy for checking access
export const planHierarchy: PlanType[] = ['free', 'starter', 'creator', 'pro', 'ultimate']

export const hasAccessToPlan = (userPlan: PlanType, requiredPlan: PlanType): boolean => {
  const userIndex = planHierarchy.indexOf(userPlan)
  const requiredIndex = planHierarchy.indexOf(requiredPlan)
  return userIndex >= requiredIndex
}

export const mainNavItems: NavItem[] = [
  { icon: Home, label: 'Home', href: '/' },
  { icon: FolderOpen, label: 'Assets', href: '/assets' },
  { icon: CreditCard, label: 'Upgrade', href: '/billing', isSpecial: true },
]

export const createNavItems: NavItem[] = [
  { icon: Users, label: 'Characters', href: '/characters' },
  { icon: Video, label: 'AI Video', href: '/video' },
  { icon: Image, label: 'AI Images', href: '/images' },
]

export const utilitiesNavItems: NavItem[] = [
  { icon: Film, label: 'Extend Video', href: '/extend-video', requiresPlan: 'creator' },
]
